import { jsx as _jsx } from "react/jsx-runtime";
import { createRoot } from 'react-dom/client';
import App from './App';
import './global.css';
document.body.innerHTML = '<div id="app"></div>';
// Render your React component instead
var root = createRoot(document.getElementById('app'));
root.render(_jsx(App, {}));
